module.exports = __webpack_public_path__ + "img/account_title.afb58b8a.png";